// extracted by mini-css-extract-plugin
module.exports = {"heading":"Canvas_heading__okxhC","wrapper":"Canvas_wrapper__2n1xs","canvas":"Canvas_canvas__3keES"};